import Dark from 'quasar/src/plugins/Dark.js';;

export const THEME_STORAGE_KEY = "app-theme";

export type ThemeMode = "light" | "dark";

function isDark(mode: ThemeMode): boolean {
  return mode === "dark";
}

export function getThemeMode(): ThemeMode {
  if (typeof window === "undefined") {
    return "light";
  }
  return localStorage.getItem(THEME_STORAGE_KEY) === "dark" ? "dark" : "light";
}

export function applyThemeAttribute(mode: ThemeMode): void {
  const root = document.documentElement;
  const dark = isDark(mode);

  root.setAttribute("data-theme", mode);
  root.classList.toggle("theme-dark", dark);

  if (document.body) {
    document.body.classList.toggle("theme-dark", dark);
  }
}

export function applyThemeMode(mode: ThemeMode): void {
  applyThemeAttribute(mode);

  try {
    Dark.set(isDark(mode));
  } catch {
    // Quasar may not be initialized yet during bootstrap.
  }
}

/** Call before Vue/Quasar mount to avoid flash and set CSS variables early. */
export function bootstrapThemeMode(): ThemeMode {
  const mode = getThemeMode();
  applyThemeAttribute(mode);
  return mode;
}

/** Call after Quasar.use() so Dark plugin is available. */
export function initThemeMode(): ThemeMode {
  const mode = getThemeMode();
  applyThemeMode(mode);
  return mode;
}

export function toggleThemeMode(): ThemeMode {
  const next: ThemeMode = isDark(getThemeMode()) ? "light" : "dark";
  localStorage.setItem(THEME_STORAGE_KEY, next);
  applyThemeMode(next);
  return next;
}

export function isDarkMode(): boolean {
  return isDark(getThemeMode());
}
